module.exports = __webpack_public_path__ + "static/media/infoIconYellow.bc358244.png";